import prepareDetails from "@helpers/prepareDetails";
import axios from "@common/api/desktop/axios";

class Collections {
  addComment = async (collectionId, comment) => {
    const response = await axios.put(`Collections/comments/add`, {
      collectionId,
      comment,
    });
    return response.data;
  };

  getVarianceHistory = async (operatorId, siteId, option) => {
    const response = await axios.get(
      `Collections/variancehistory/${operatorId},${siteId},${option}`,
    );
    return response.data;
  };

  getVarianceHistoryByMin = async (operatorId, min) => {
    const response = await axios.get(
      `collections/variancehistorybymin/${operatorId},${min}`,
    );
    return response.data;
  };

  getVarianceHistoryExport = async (operatorId, siteId, option) => {
    const response = await axios.get(
      `Collections/variancehistory/export/${operatorId},${siteId},${option}`,
      { responseType: "arraybuffer" },
    );
    return response;
  };

  getVarianceHistoryOptions = async (operatorId, siteId) => {
    const response = await axios.get(
      `Collections/variancehistory/options/${operatorId},${siteId}`,
    );
    return response.data;
  };

  getCommentsByCollection = async (collectionId) => {
    const response = await axios.get(
      `Collections/comments/bycollection/${collectionId}`,
    );
    return response.data;
  };

  getComments = async (operatorId, siteId, periodId) => {
    const response = await axios.get(
      `Collections/comments/byCollection2/${operatorId},${siteId},${periodId}`,
    );
    return response.data;
  };

  getCommentsByInstallation = async (installationId) => {
    const response = await axios.get(
      `Collections/comments/byInstallation/${installationId}`,
    );
    return response.data;
  };

  getCommentsByBatchId = async (batchId) => {
    const collectionType = 0;
    const response = await axios.get(
      `Collections/comments/byCollection2/${collectionType},${batchId}`,
    );
    return response.data;
  };

  getPeriods = async (operatorId, siteId) => {
    const response = await axios.get(
      `Collections/banking/week/periods/${operatorId},${siteId}`,
    );
    return response.data;
  };

  getBankingWeek = async (operatorId, siteId, fromId, toId) => {
    const response = await axios.get(
      `Collections/banking/week/${operatorId},${siteId},${fromId},${toId}`,
    );
    return response.data;
  };

  getBankingWeekExport = async (operatorId, siteId, fromId, toId) => {
    const response = await axios.get(
      `Collections/banking/week/export/${operatorId},${siteId},${fromId},${toId}`,
      { responseType: "arraybuffer" },
    );
    return response;
  };

  getBankingWeekByEgm = async (detailRef) => {
    const response = await axios.get(
      `Collections/banking/week/byEGM/${detailRef}`,
    );
    return response.data;
  };

  getBankingWeekTransactions = async (CollectionId, details) => {
    const response = await axios.put(
      `Collections/banking/week/byEGM/transactions/filter`,
      { CollectionId, Details: prepareDetails(details) },
    );
    return response.data;
  };

  getBankingPerformanceExport = async (
    operatorId,
    siteId,
    fromId,
    toId,
    showDetails,
  ) => {
    const response = await axios.get(
      `Collections/performance/week/export/${operatorId},${siteId},${fromId},${toId},${showDetails}`,
      { responseType: "arraybuffer" },
    );
    return response;
  };

  getBankingWeekDetail = async (operatorId, siteId, batchId) => {
    const response = await axios.get(
      `Collections/banking/week/detail/batch/${operatorId},${siteId},${batchId}`,
    );
    return response.data;
  };

  getBankingWeekDetailGrid = async (operatorId, siteId, periodId) => {
    const response = await axios.get(
      `Collections/banking/week/detail/batch/detail/${operatorId},${siteId},${periodId}`,
    );
    return response.data;
  };

  getBankingWeekKioskGrid = async (operatorId, siteId, periodId) => {
    const response = await axios.get(
      `Collections/banking/week/detail/batch/kiosk/${operatorId},${siteId},${periodId}`,
    );
    return response.data;
  };

  getBankingWeekSummaryGrid = async (operatorId, siteId, periodId) => {
    const response = await axios.get(
      `Collections/banking/week/detail/batch/summary/${operatorId},${siteId},${periodId}`,
    );
    return response.data;
  };

  getBankingPerformanceDetail = async (operatorId, siteId, batchId) => {
    const response = await axios.get(
      `Collections/performance/week/detail/batch/${operatorId},${siteId},${batchId}`,
    );
    return response.data;
  };

  getBankingPerformanceDetailGrid = async (operatorId, siteId, periodId) => {
    const response = await axios.get(
      `Collections/performance/week/detail/batch/detail/${operatorId},${siteId},${periodId}`,
    );
    return response.data;
  };

  getBankingPerformanceCategoryGrid = async (operatorId, siteId, periodId) => {
    const response = await axios.get(
      `Collections/performance/week/detail/batch/category/${operatorId},${siteId},${periodId}`,
    );
    return response.data;
  };

  getBankingPerformanceSummaryGrid = async (operatorId, siteId, periodId) => {
    const response = await axios.get(
      `Collections/performance/week/detail/batch/summary/${operatorId},${siteId},${periodId}`,
    );
    return response.data;
  };

  getBankingPerformance = async (
    operatorId,
    siteId,
    fromId,
    toId,
    showDetails,
  ) => {
    const response = await axios.get(
      `Collections/performance/week/${operatorId},${siteId},${fromId},${toId},${showDetails}`,
    );
    return response.data;
  };

  getBankingPerformanceByEgm = async (detailRef) => {
    const response = await axios.get(
      `Collections/performance/week/byEGM/${detailRef}`,
    );
    return response.data;
  };

  getMachinePerformancePdf = async (batchId) => {
    const response = await axios.get(
      `Report/Collection/Batch/Performance/Analysis/PDF/${batchId}`,
      { responseType: "arraybuffer" },
    );
    return response;
  };

  getMachinePerformanceCsv = async (batchId) => {
    const response = await axios.get(
      `Report/Collection/Batch/Performance/Analysis/CSV/${batchId}`,
      { responseType: "arraybuffer" },
    );
    return response;
  };

  getSummaryReportPdf = async (batchId) => {
    const response = await axios.get(
      `Report/Collection/Batch/Summary/PDF/${batchId}`,
      { responseType: "arraybuffer" },
    );
    return response;
  };

  getBankingSummaryPdf = async (batchId) => {
    const response = await axios.get(
      `Report/Collection/Batch/Banking/Summary/PDF/${batchId}`,
      { responseType: "arraybuffer" },
    );
    return response;
  };

  getBankingVariancePdf = async (batchId) => {
    const response = await axios.get(
      `Report/Collection/Batch/Banking/Variance/PDF/${batchId}`,
      { responseType: "arraybuffer" },
    );
    return response;
  };

  getPerformanceSummaryPdf = async (batchId) => {
    const response = await axios.get(
      `Report/Collection/Batch/Performance/Summary/PDF/${batchId}`,
      { responseType: "arraybuffer" },
    );
    return response;
  };

  getPerformanceSummaryCsv = async (batchId) => {
    const response = await axios.get(
      `report/Collection/Batch/Performance/Summary/CSV/${batchId}`,
      { responseType: "arraybuffer" },
    );
    return response;
  };

  getPerformanceVariancePdf = async (batchId) => {
    const response = await axios.get(
      `Report/Collection/Batch/Performance/Variance/PDF/${batchId}`,
      { responseType: "arraybuffer" },
    );
    return response;
  };

  editMeter = async (meterRef) => {
    const response = await axios.get(`Collections/meter/edit/${meterRef}`);
    return response.data;
  };

  updateMeter = async (meterRef, details) => {
    const response = await axios.put(`Collections/meter/update`, {
      meterRef,
      complete: true,
      details: prepareDetails(details),
    });
    return response.data;
  };

  refreshMeter = async (detailRef) => {
    const response = await axios.get(
      `Collections/banking/week/byEGM/Meters/${detailRef}`,
    );
    return response.data;
  };

  getPromoTickets = async (collectionId) => {
    const response = await axios.get(
      `Collections/promotickets/bycollection/${collectionId}`,
    );
    return response.data;
  };

  getTicketsInKiosk = async (collectionId, details) => {
    const response = await axios.post(
      `Collections/ticketsinkioskcd/bycollection/`,
      { collectionId, details: prepareDetails(details) },
    );
    return response.data;
  };

  getTickets = async (collectionId, details) => {
    const response = await axios.post(`Collections/tickets/bycollection/`, {
      collectionId,
      details: prepareDetails(details),
    });
    return response.data;
  };

  getEvents = async (collectionId) => {
    const response = await axios.get(
      `Collections/events/bycollection/${collectionId}`,
    );
    return response.data;
  };

  declareCountEdit = async (collectionType, collectionId) => {
    const response = await axios.get(
      `Collections/declare/edit/${collectionType},${collectionId}`,
    );
    return response.data;
  };

  declareCountSave = async (data) => {
    const response = await axios.put(`Collections/declare/update`, data);
    return response.data;
  };
}

const collections = new Collections();

export default collections;
